export default "__VITE_PUBLIC_ASSET__76a4b0de__"